/**
 * קובץ עזר למניעת לוגים בסביבת ייצור
 */

// שומר את פונקציות ה-console המקוריות
const originalConsole = {
  /* eslint-disable no-console */
  log: console.log,
  warn: console.warn,
  info: console.info,
  debug: console.debug,
  error: console.error
  /* eslint-enable no-console */
};

/**
 * מדכא את כל פונקציות הלוגים, ללא תלות בסביבה
 * @param {boolean} keepErrors - האם לשמור את console.error פעיל
 */
export function suppressAllLogs(keepErrors = true): void {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.log = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.warn = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.info = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  console.debug = () => {};
  
  // אופציונלי: לדכא גם שגיאות
  if (!keepErrors) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    console.error = () => {};
  }
}

/**
 * מדכא את כל פונקציות הלוגים בסביבת ייצור
 * @param {boolean} keepErrors - האם לשמור את console.error פעיל
 */
export function suppressLogsInProduction(keepErrors = true): void {
  if (process.env.NODE_ENV === 'production') {
    suppressAllLogs(keepErrors);
  }
}

/**
 * פונקציה שיכולה להחזיר את המצב המקורי (לשימוש בדיבוג)
 */
export function restoreConsole(): void {
  /* eslint-disable no-console */
  console.log = originalConsole.log;
  console.warn = originalConsole.warn;
  console.info = originalConsole.info;
  console.debug = originalConsole.debug;
  console.error = originalConsole.error;
  /* eslint-enable no-console */
}

export default {
  suppressLogsInProduction,
  suppressAllLogs,
  restoreConsole
}; 